import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/ui/components/Button';
import { Checkbox } from '@/ui/components/Checkbox/Checkbox';
import { Icon } from '@/ui/icons/Icon';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { mobilePhoneWithArrow } from '@/assets/images/emojis';
import { externalUrls } from '@/constants/urls';
import { maskPhoneForDisplay } from '@/lib/phoneUtils';
import { routes } from '@/routes/routes';
import { useError } from '@/providers/Error';
import { genericMessages, phoneOtpMessages } from '@/constants/errorMessages';
import { useBrokerOtp } from '../../hooks';
import styles from './BrokerConfirmPhonePage.module.scss';

export function BrokerConfirmPhonePage() {
  const { offerId } = useParams<{ offerId: string }>();
  const navigate = useNavigate();
  const { setError } = useError();
  const [agreed, setAgreed] = useState(false);

  const { applicant, isLoadingApplicant, requestOtp, isRequestingOtp } =
    useBrokerOtp(offerId);

  if (isLoadingApplicant) {
    return <PageLoader />;
  }

  const handleSendCode = async () => {
    try {
      const response = await requestOtp();
      if (!response.isSuccess) {
        setError(
          phoneOtpMessages[response.error as keyof typeof phoneOtpMessages] ??
            genericMessages.unexpected
        );
        return;
      }
      navigate(routes.brokerOffer.otp(offerId as string));
    } catch {
      setError(genericMessages.unexpected);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.top}>
        <div className={styles.header}>
          <img src={mobilePhoneWithArrow} alt="" className={styles.emoji} />
          <h1 className={styles.title}>Confirmă numărul tău</h1>
        </div>

        <div className={styles.phoneCard}>
          <p className={styles.phone}>
            {maskPhoneForDisplay(applicant?.phone ?? '')}
          </p>
        </div>

        <div className={styles.wrongNumber}>
          <span className={styles.wrongNumberLabel}>Număr greșit?</span>
          <a
            className={styles.downloadLink}
            href={externalUrls.volt.appDownload}
            target="_blank"
            rel="noreferrer"
          >
            Descarcă Volt pentru a continua
          </a>
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.consent}>
          <Checkbox
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span className={styles.consentText}>
            Sunt de acord cu{' '}
            <a
              className={styles.consentLink}
              href={externalUrls.volt.privacy}
              target="_blank"
              rel="noreferrer"
            >
              Politica de Confidențialitate.
            </a>
          </span>
        </div>

        <Button
          variant="filled"
          size="medium"
          className={styles.submit}
          text="Trimite codul SMS"
          rightIcon={<Icon name="arrow-right" size={16} />}
          disabled={!agreed}
          loading={isRequestingOtp}
          onClick={handleSendCode}
          trackingId="broker_offer_request_otp"
        />
      </div>
    </div>
  );
}
